import { render, staticRenderFns } from "./AccettazioneSsnAppuntamentoCardComponent.vue?vue&type=template&id=1345ef7c&scoped=true"
import script from "./AccettazioneSsnAppuntamentoCardComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAppuntamentoCardComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnAppuntamentoCardComponent.vue?vue&type=style&index=0&id=1345ef7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345ef7c",
  null
  
)

export default component.exports